$(document).ready(function () {
  $('.product-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    autoplay: false,
    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
    
  });
});


if (document.querySelector('.template-collection-stone-template')) {
    const priceInfoElements = document.querySelectorAll('.per__price');
    priceInfoElements.forEach(priceInfoElement => {
        priceInfoElement.innerHTML = '/square ft.';
    });
}
if (document.querySelector('.template-collection-accessories-template')) {
    const priceInfoElements = document.querySelectorAll('.per__price');
    priceInfoElements.forEach(priceInfoElement => {
        priceInfoElement.innerHTML = '/piece';
    });
}


// collections slider

// if(window.outerWidth < 990) {

// $('.coll_slider').slick({
//   arrow:false,
//   dots:false,
//   centerMode: true,
//   centerPadding: '80px',
//   slidesToShow: 3,
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: '40px',
//         slidesToShow: 3
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: '40px',
//         slidesToShow: 1
//       }
//     }
//   ]
// });
// }


    $('.home_images').slick({
  dots: true,
      arrow:false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1
});





$('.case_study').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0741/8668/6700/files/right-arrow_1.png?v=1736410621'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0741/8668/6700/files/right-arrow_1.png?v=1736410621'></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
     {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 749,
      settings: {
        centerMode: true,
        centerPadding: '70px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$('.pro_banner').slick({
  infinite: true,
  fade: true,
  cssEase: 'linear',
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0741/8668/6700/files/Vector_6.png?v=1736849027'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0741/8668/6700/files/Vector_6.png?v=1736849027'></button>"
});


  $('.project_slider').slick({
  infinite: true,
    dots: true,
  slidesToShow: 1,
  slidesToScroll: 5
});




$(document).ready(function() {
  $('.collection-grid-controller__button').on('click', function() {
    // Remove 'active' class from all buttons
    $('.collection-grid-controller__button').removeClass('active');
    
    // Add 'active' class to the clicked button
    $(this).addClass('active');

    // Get the name attribute of the clicked button
    var gridType = $(this).attr('name');

    // Update the product grid class based on the button clicked
    $('.product-grid').removeClass('grid-two-down grid-one-down').addClass(gridType);
  });
});


$(document).ready(function () {
    var $filterItem = $(".collection-filter__item");

    function handleScroll() {
        if ($(window).width() <= 768) { // Adjust breakpoint as needed
            if ($(window).scrollTop() > 500) {
                $filterItem.addClass("scrolled");
            } else {
                $filterItem.removeClass("scrolled");
            }
        } else {
            $filterItem.removeClass("scrolled"); // Remove class if resized to desktop
        }
    }

    $(window).on("scroll", handleScroll);
    $(window).on("resize", handleScroll); // Handle resize events
});

$(document).ready(function() {
    $('.footer_search_pt .search__input.field__input').on('input', function() {
      const inputLength = $(this).val().length;
      if (inputLength > 0) {
        $('body').addClass('active_input');
        } else {
        $('body').addClass('active_input');
      }
    });
  });
$(document).ready(function() {
    $('.custom_predictive_search .search__input.field__input').on('input', function() {
      const inputLength = $(this).val().length;
      if (inputLength > 0) {
        $('body').removeClass('active_input');
        } 
    });
  });



